import React from 'react';

import Switch from '@mui/material/Switch';

interface DeepResearchSwitchProps {
  isDeepResearchActive: boolean;
  onToggle: () => void;
}

const DeepResearchSwitch = ({ isDeepResearchActive, onToggle }: DeepResearchSwitchProps) => {
  return (
    <div className="mt-40 flex items-center justify-center sm:mt-32">
      <Switch
        id="activateDeepResearch"
        className="!h-56 !w-72 [&_.Mui-checked+.MuiSwitch-track]:border-pro-gold [&_.Mui-checked+.MuiSwitch-track]:bg-pro-gold [&_.Mui-checked+.MuiSwitch-track]:opacity-100 [&_.MuiSwitch-switchBase.Mui-checked]:p-[14px_8px] [&_.MuiSwitch-switchBase.Mui-checked]:text-white [&_.MuiSwitch-switchBase]:left-[2px] [&_.MuiSwitch-switchBase]:p-[14px_12px] [&_.MuiSwitch-switchBase]:text-primary-black [&_.MuiSwitch-thumb]:h-[28px] [&_.MuiSwitch-thumb]:w-[28px] [&_.MuiSwitch-track]:h-[32px] [&_.MuiSwitch-track]:w-[52px] [&_.MuiSwitch-track]:rounded-[32px] [&_.MuiSwitch-track]:border [&_.MuiSwitch-track]:border-solid [&_.MuiSwitch-track]:border-black [&_.MuiSwitch-track]:bg-transparent [&_.MuiSwitch-track]:opacity-100 [&_.css-5ryogn-MuiButtonBase-root-MuiSwitch-switchBase:hover]:bg-transparent"
        checked={isDeepResearchActive}
        onChange={onToggle}
      ></Switch>
      <span className="ml-2 font-suisse-intl text-button-md sm:max-w-[310px]">
        {isDeepResearchActive ? 'Deep Research active' : 'Activate Deep Research'}
      </span>
    </div>
  );
};

export default DeepResearchSwitch;
